import request from '@/utils/request'

// 广告主列表
export function advertiserList(params) {
  return request({
    url: '/account_management/advertisers',
    method: 'get',
    params
  })
}

export function getQrCode(params = {}) {
  return request({
    url: '/ad_copy/auth_wechat_scan',
    method: 'get',
    params
  })
}

// 一键清除
export function eliminate(params = {}) {
  return request({
    url: '/account_management/clear',
    method: 'get',
    params
  })
}
// 修改账号名称
export function change_name(data = {}) {
  return request({
    url: '/account_management/change_name',
    method: 'post',
    data
  })
}
// 修改APPId
export function change_app_id(data = {}) {
  return request({
    url: '/account_management/change_app_id',
    method: 'post',
    data
  })
}
// 批量拉取素材和素材报表  腾讯
export function advertisers(data = {}) {
  return request({
    url: '/account_management/advertisers/batch_pull_material_and_cost_day',
    method: 'post',
    data
  })
}
// 批量更新用户QQ下广告主的行为数据源
export function adgroupsQQ(params = {}) {
  return request({
    url: '/ad_management/account/adgroups/update_appoint_admin_user_action_sets',
    method: 'get',
    params
  })
}
// /用户QQ关联的广告组
export function adgroupsindex(params = {}) {
  return request({
    url: '/ad_management/account_v3/adgroups/index',
    method: 'get',
    params
  })
}
// 用户QQ关联的广告创意
export function dynamic_creativeindex(params = {}) {
  return request({
    url: '/ad_management/account_v3/dynamic_creative/index',
    method: 'get',
    params
  })
}
// 复制任务列表
export function job_list(params = {}) {
  return request({
    url: '/ad_copy/job_list',
    method: 'get',
    params
  })
}
// 任务执行记录
export function job_record_list(params = {}) {
  return request({
    url: '/ad_copy/job_record_list',
    method: 'get',
    params
  })
}
// 重试任务
export function retry_failed_record(data = {}) {
  return request({
    url: '/ad_copy/retry_failed_record',
    method: 'post',
    data
  })
}
// 复制广告组
export function copy_ad_adq_v3(data = {}) {
  return request({
    url: '/ad_copy/copy_ad_adq_v3',
    method: 'post',
    data
  })
}
// 素材图片列表
export function material_images(params = {}) {
  return request({
    url: '/ad_management/account_v3/material_images/list',
    method: 'get',
    params
  })
}
// 素材视频列表
export function material_videos(params = {}) {
  return request({
    url: '/ad_management/account_v3/material_videos/list',
    method: 'get',
    params
  })
}
// 素材弹幕列表
export function material_barrage(params = {}) {
  return request({
    url: '/ad_management/account_v3/material_barrage/list',
    method: 'get',
    params
  })
}
// 素材品牌形象列表
export function material_brand(params = {}) {
  return request({
    url: '/ad_management/account_v3/material_brand/list',
    method: 'get',
    params
  })
}
// 素材朋友圈头像昵称跳转页
export function material_profiles(params = {}) {
  return request({
    url: '/ad_management/account_v3/material_profiles/list',
    method: 'get',
    params
  })
}
// 创建品牌形象素材
export function material_brandCreate(data = {}) {
  return request({
    url: '/ad_management/account_v3/material_brand/create',
    method: 'post',
    data
  })
}
// 创建图片素材
export function material_imagesCreate(data = {}) {
  return request({
    url: '/ad_management/account_v3/material_images/create',
    method: 'post',
    data
  })
}
// 创建视频素材
export function material_videosCreate(data = {}) {
  return request({
    url: '/ad_management/account_v3/material_videos/create',
    method: 'post',
    data
  })
}
// 创建朋友圈头像昵称跳转页素材
export function material_profilesCreate(data = {}) {
  return request({
    url: '/ad_management/account_v3/material_profiles/create',
    method: 'post',
    data
  })
}
// 创建弹幕素材(官方接口有问题)
export function material_barrageCreate(data = {}) {
  return request({
    url: '/ad_management/account_v3/material_barrage/create',
    method: 'post',
    data
  })
}
// 原生落地页列表
export function material_wechat_pages(params = {}) {
  return request({
    url: '/ad_management/account_v3/material_wechat_pages/list',
    method: 'get',
    params
  })
}
// 可投放推广内容资产列表
export function material_marketing_target_assets(params = {}) {
  return request({
    url: '/ad_management/account_v3/material_marketing_target_assets/list',
    method: 'get',
    params
  })
}
// 短剧售卖策略列表
export function landing_page_sell_strategy(params = {}) {
  return request({
    url: '/ad_management/account_v3/landing_page_sell_strategy/list',
    method: 'get',
    params
  })
}
// 监测链接组列表
export function feedback_info(params = {}) {
  return request({
    url: '/ad_management/account_v3/feedback_info/list',
    method: 'get',
    params
  })
}
// 创建短剧售卖策略
export function landing_page_sell_strategyCreate(data = {}) {
  return request({
    url: '/ad_management/account_v3/landing_page_sell_strategy/create',
    method: 'post',
    data
  })
}
// 创建监测链接组
export function feedback_infoCreate(data = {}) {
  return request({
    url: '/ad_management/account_v3/feedback_info/create',
    method: 'post',
    data
  })
}
// 同步账户资产
export function materialSync(data = {}) {
  return request({
    url: '/ad_management/account_v3/material/sync',
    method: 'post',
    data
  })
}
// 同步产品广告
export function delAdsByMarketingAssetName(data = {}) {
  return request({
    url: '/ad_copy/del_ads_by_marketing_asset_name',
    method: 'post',
    data
  })
}
// 微信授权账户列表
export function wechat_auth_account(params = {}) {
  return request({
    url: '/account_management/wechat_auth_account/list',
    method: 'get',
    params
  })
}
// 获取微信授权二维码
export function simulation_auth_wechat(params = {}) {
  return request({
    url: '/simulation_auth_wechat',
    method: 'get',
    params
  })
}
// 分配微信授权账户
export function wechat_auth_accountShare(data = {}) {
  return request({
    url: '/account_management/wechat_auth_account/share',
    method: 'post',
    data
  })
}
// 批量更新指定广告主的广告
export function wechat_auth_accountCancel(data = {}) {
  return request({
    url: '/account_management/wechat_auth_account/cancel',
    method: 'post',
    data
  })
}
// 获取管理员列表接口
export function wechat_auth_accountAdmin(params = {}) {
  return request({
    url: '/account_management/wechat_auth_account/admin',
    method: 'get',
    params
  })
}
// 授权信息管理列表
export function adq_mkt_api_authManage(params = {}) {
  return request({
    url: '/adq_mkt_api_auth/manage',
    method: 'get',
    params
  })
}
// 新增授权信息
export function adq_mkt_api_authManageadd(data = {}) {
  return request({
    url: '/adq_mkt_api_auth/manage',
    method: 'post',
    data
  })
}
// 更新授权信息
export function adq_mkt_api_authManageupdata(id, data) {
  return request({
    url: `/adq_mkt_api_auth/manage/${id}`,
    method: 'put',
    data
  })
}
// 根据id查找授权信息
export function adq_mkt_api_authManageLook(params = {}) {
  return request({
    url: '/adq_mkt_api_auth/manage',
    method: 'get',
    params
  })
}
// 根据id删除授权信息
export function adq_mkt_api_authManageDELETE(id) {
  return request({
    url: `/adq_mkt_api_auth/manage/${id}`,
    method: 'DELETE'
  })
}
// 授权账户
export function auth_accountShare(data = {}) {
  return request({
    url: '/adq_mkt_api_auth/auth_account/share',
    method: 'post',
    data
  })
}
// 授权账户记录列表
export function auth_accountTask_record(params = {}) {
  return request({
    url: '/adq_mkt_api_auth/auth_account/task_record',
    method: 'get',
    params
  })
}
// 广告主列表
export function account_managementAdvertisers(params = {}) {
  return request({
    url: '/account_management/advertisers',
    method: 'get',
    params
  })
}
// 查找项目列表
export function projectIndex(params = {}) {
  return request({
    url: '/ocean/account/project/index',
    method: 'get',
    params
  })
}
// 查找广告列表
export function promotionIndex(params = {}) {
  return request({
    url: '/ocean/account/promotion/index',
    method: 'get',
    params
  })
}
// 复制广告项目
export function job_create(data = {}) {
  return request({
    url: '/ocean/copy/job_create',
    method: 'post',
    data
  })
}
// 复制任务列表
export function copyJob_list(params = {}) {
  return request({
    url: '/ocean/copy/job_list',
    method: 'get',
    params
  })
}
// 任务执行记录
export function copyJob_record_list(params = {}) {
  return request({
    url: '/ocean/copy/job_record_list',
    method: 'get',
    params
  })
}
// 素材图片列表巨量
export function imageList(params = {}) {
  return request({
    url: '/ocean/material/image/list',
    method: 'get',
    params
  })
}
// 素材视频列表巨量
export function videoList(params = {}) {
  return request({
    url: '/ocean/material/video/list',
    method: 'get',
    params
  })
}
// 同步账户资产
export function oceanMaterialSync(data = {}) {
  return request({
    url: '/ocean/material/sync',
    method: 'post',
    data
  })
}
// 终止复制任务
export function copyJob_stop(data = {}) {
  return request({
    url: '/ocean/copy/job_stop',
    method: 'post',
    data
  })
}
// 重试任务
export function copyRetry_failed_record(data = {}) {
  return request({
    url: '/ocean/copy/retry_failed_record',
    method: 'post',
    data
  })
}

// 投放规则列表
export function InterPutRuleList(params) {
  return request({
    url: '/intelligent_management/delivery_rule/index',
    method: 'get',
    params
  })
}

// 投放规则创建
export function InterPutRuleInsert(data = {}) {
  return request({
    url: '/intelligent_management/delivery_rule/store',
    method: 'post',
    data
  })
}

// 投放规则删除
export function InterPutRuleDelete(data = {}) {
  return request({
    url: '/intelligent_management/delivery_rule/destroy',
    method: 'post',
    data
  })
}

// 投放规则更新
export function InterPutRuleUpdate(data = {}) {
  return request({
    url: '/intelligent_management/delivery_rule/update',
    method: 'post',
    data
  })
}
// 投放规则绑定的广告账号列表
export function InterPutRuleBandAccountList(params) {
  return request({
    url: '/intelligent_management/delivery_account/index',
    method: 'get',
    params
  })
}

// 投放规则绑定的广告账号更新状态
export function InterPutRuleBandAccountUpdSts(data = {}) {
  return request({
    url: '/intelligent_management/delivery_account/update_status',
    method: 'post',
    data
  })
}
// 投放规则绑定的广告账号更新状态
export function InterPutRuleBandAccountBind(data = {}) {
  return request({
    url: '/intelligent_management/delivery_account/store',
    method: 'post',
    data
  })
}
// 投放规则绑定的广告账号解绑
export function InterPutRuleUnBand(data = {}) {
  return request({
    url: '/intelligent_management/delivery_account/destroy',
    method: 'post',
    data
  })
}

// 投放规则绑定的广告账号自动开启记录
export function InterPutRuleHistory(params) {
  return request({
    url: '/intelligent_management/delivery_rule/reject_examine_record',
    method: 'get',
    params
  })
}
// 广告回传配置
export function backRuleAdminlist(params = {}) {
  return request({
    url: '/ocean/report/rule_list',
    method: 'get',
    params
  })
}
// 广告回传配置删除
export function backRuleAdmindelete(data) {
  return request({
    url: '/ocean/report/rule_delete',
    method: 'post',
    data
  })
}
// 广告回传配置新增
export function backRuleAdmincreate(data) {
  return request({
    url: '/ocean/report/rule_add',
    method: 'post',
    data
  })
}
// 广告回传配置更新
export function backRuleAdminupdate(data) {
  return request({
    url: '/ocean/report/rule_edit',
    method: 'post',
    data
  })
}
// 监测链接列表
export function monitorLinkList(params = {}) {
  return request({
    url: '/ocean/report/monitor_link_list',
    method: 'get',
    params
  })
}
// 检测列表新增
export function monitorLinkAdd(data) {
  return request({
    url: '/ocean/report/monitor_link_add',
    method: 'post',
    data
  })
}
// 修改账户备注
export function account_mchange_remark(data = {}) {
  return request({
    url: '/account_management/change_remark',
    method: 'post',
    data
  })
}
// 修改账户标签
export function account_mchange_tag(data = {}) {
  return request({
    url: '/account_management/change_tag',
    method: 'post',
    data
  })
}
// 过审列表
export function reviewedlinklist(params = {}) {
  return request({
    url: '/reviewed_link/list',
    method: 'get',
    params
  })
}
// 过审列表删除
export function reviewedlinkdelete(data) {
  return request({
    url: '/reviewed_link/delete',
    method: 'post',
    data
  })
}
// 过审链接创建
export function reviewedlinkcreate(data) {
  return request({
    url: '/reviewed_link/create',
    method: 'post',
    data
  })
}
// 回传事件列表
export function reportEventList(data) {
  return request({
    url: '/ocean/report/event_list',
    method: 'get',
    data
  })
}
// 企微员工列表
export function employeeList(params = {}) {
  return request({
    url: '/ocean/report/employee_list',
    method: 'GET',
    params
  })
}
// 批量停止广告
export function stopCopyAd(data) {
  return request({
    url: 'ad_copy/stop_copy_ad',
    method: 'post',
    data
  })
}
// 批量修改出价
export function updAdBid(data) {
  return request({
    url: '/ad_copy/upd_ad_bid',
    method: 'post',
    data
  })
}
// 批量修改投放日期/时间
export function batchUpdateDate(data) {
  return request({
    url: '/ad_copy/batch_update_date',
    method: 'post',
    data
  })
}
// 批量修改人群包
export function updAdCustom(data) {
  return request({
    url: '/ad_copy/upd_ad_exclude_custom',
    method: 'post',
    data
  })
}
// 批量删除
export function delAdCustom(data) {
  return request({
    url: '/ad_copy/del_ads',
    method: 'post',
    data
  })
}
// 复制队列数量列表
export function getCopyQueueList(data) {
  return request({
    url: 'ad_copy/get_copy_queue',
    method: 'get',
    data
  })
}
// 新增复制队列
export function addCopyQue(data) {
  return request({
    url: 'ad_copy/set_copy_queue',
    method: 'post',
    data
  })
}
// 广告回传配置
export function tencentBackRuleAdminlist(params = {}) {
  return request({
    url: '/ad_management/adq_report/rule_list',
    method: 'get',
    params
  })
}
// 广告回传配置新增
export function tencentBackRuleAdmincreate(data) {
  return request({
    url: '/ad_management/adq_report/rule_add',
    method: 'post',
    data
  })
}
// 广告回传配置新增
export function tencentBackRuleAdminupdate(data) {
  return request({
    url: '/ad_management/adq_report/rule_edit',
    method: 'post',
    data
  })
}
// 腾讯广告回传配置删除
export function tencentBackRuleAdmindelete(data) {
  return request({
    url: '/ad_management/adq_report/rule_delete',
    method: 'post',
    data
  })
}
// 复制广告项目变色龙
export function copyv2jobcreate(data = {}) {
  return request({
    url: '/ocean/copy_v2/job_create',
    method: 'post',
    data
  })
}
// 复制任务列表(变色龙)
export function copyJobV2_list(params = {}) {
  return request({
    url: '/ocean/copy_v2/job_list',
    method: 'get',
    params
  })
}
// 任务执行记录(变色龙)
export function copyJobV2_record_list(params = {}) {
  return request({
    url: '/ocean/copy_v2/job_record_list',
    method: 'get',
    params
  })
}
// 重试任务(变色龙)
export function copyRetryV2_failed_record(data = {}) {
  return request({
    url: '/ocean/copy_v2/retry_failed_record',
    method: 'post',
    data
  })
}
// 终止复制任务(变色龙)
export function copyJobV2_stop(data = {}) {
  return request({
    url: '/ocean/copy_v2/job_stop',
    method: 'post',
    data
  })
}
// 复制队列数量列表(变色龙)
export function getCopyQueueListbsl(data) {
  return request({
    url: '/ocean/copy_v2/get_copy_queue',
    method: 'get',
    data
  })
}
// 新增复制队列(变色龙)
export function addCopyQuebsl(data) {
  return request({
    url: '/ocean/copy_v2/set_copy_queue',
    method: 'post',
    data
  })
}

// 资金账户信息
export function getFunds(params = {}) {
  return request({
    url: '/account_management/get_funds',
    method: 'get',
    params
  })
}
// 爱奇艺回传配置列表
export function iqiyireportrulelist(params = {}) {
  return request({
    url: '/iqiyi/report/rule_list',
    method: 'get',
    params
  })
}
// 爱奇艺广告回传配置删除
export function iqiyireportruledelete(data) {
  return request({
    url: '/iqiyi/report/rule_delete',
    method: 'post',
    data
  })
}
// 爱奇艺广告回传配置新增
export function iqiyireportruleadd(data) {
  return request({
    url: '/iqiyi/report/rule_add',
    method: 'post',
    data
  })
}
// 爱奇艺广告回传配置编辑
export function iqiyireportruleedit(data) {
  return request({
    url: '/iqiyi/report/rule_edit',
    method: 'post',
    data
  })
}
// 提交爱奇艺落地页
export function addhtmlstr(data) {
  return request({
    url: '/iqiyi/landing_page/add',
    method: 'post',
    data
  })
}
// 爱奇艺落地页列表
export function pashewrlist(params = {}) {
  return request({
    url: '/iqiyi/landing_page/list',
    method: 'get',
    params
  })
}
// 删除爱奇艺落地页
export function iqiyilandingpagedelete(data) {
  return request({
    url: '/iqiyi/landing_page/delete',
    method: 'post',
    data
  })
}
// 获取可投放推广内容资产列表
export function marketingtargetassets(params = {}) {
  return request({
    url: '/ad_management/marketing_target_assets/index',
    method: 'get',
    params
  })
}

// 获取可投放推广内容资产列表
export function exportAccount(params = {}) {
  return request({
    url: '/account_management/export_account',
    method: 'get',
    params
  })
}

// 巨量 广告模版列表
export function adTemplateList(params = {}) {
  return request({
    url: '/ocean/setup_template/list',
    method: 'get',
    params
  })
}
// 新增巨量广告模版
export function setupTemplateCreate(data) {
  return request({
    url: '/ocean/setup_template/create',
    method: 'post',
    data
  })
}

// 删除巨量广告模版
export function setupTemplateDel(data) {
  return request({
    url: '/ocean/setup_template/delete',
    method: 'post',
    data
  })
}
// 巨量 定向区域列表
export function cityList(params = {}) {
  return request({
    url: '/ocean/setup_audience_package/city_list',
    method: 'get',
    params
  })
}

// 巨量 定向包列表
export function packageList(params = {}) {
  return request({
    url: '/ocean/setup_audience_package/list',
    method: 'get',
    params
  })
}
// 新增定向包
export function packageCreate(data) {
  return request({
    url: '/ocean/setup_audience_package/create',
    method: 'post',
    data
  })
}

// 修改定向包
export function packageUpd(data) {
  return request({
    url: '/ocean/setup_audience_package/update',
    method: 'post',
    data
  })
}

// 删除定向包
export function packageDel(data) {
  return request({
    url: '/ocean/setup_audience_package/delete',
    method: 'post',
    data
  })
}
// 巨量 任务列表
export function setupJobList(params = {}) {
  return request({
    url: '/ocean/setup_job/list',
    method: 'get',
    params
  })
}

// 巨量 任务列表 - 小程序列表
export function microApp(params = {}) {
  return request({
    url: '/ocean/setup_job/micro_app',
    method: 'get',
    params
  })
}

// 巨量 任务列表 - 抖音列表
export function iseAccount(params = {}) {
  return request({
    url: '/ocean/setup_job/ise_account',
    method: 'get',
    params
  })
}
// 巨量 任务列表 - 落地页列表
export function siteList(params = {}) {
  return request({
    url: '/ocean/setup_job/site_list',
    method: 'get',
    params
  })
}

// 巨量 - 新增任务
export function SetUpJobCreate(data) {
  return request({
    url: '/ocean/setup_job/create',
    method: 'post',
    data
  })
}
// 巨量 任务执行列表
export function jobRecordList(params = {}) {
  return request({
    url: '/ocean/setup_job/record_list',
    method: 'get',
    params
  })
}
// 巨量 任务重试
export function retryCecord(data) {
  return request({
    url: '/ocean/setup_job/retry_record',
    method: 'post',
    data
  })
}
// 巨量 任务终止
export function jobStop(data) {
  return request({
    url: '/ocean/setup_job/stop',
    method: 'post',
    data
  })
}
// 新广告主列表
export function newadvertiserList(data) {
  return request({
    url: '/account_management/advertiser_list',
    method: 'post',
    data
  })
}
